export const INTERN_TRACKS = [
  {
    id: 'software-engineering',
    title: 'Software Engineering',
    summary: 'Ship production features across our web stack — React, TypeScript, Netlify, and Supabase.',
    focus: ['Full-stack web', 'Serverless APIs', 'Product integrations'],
  },
  {
    id: 'ai-ml',
    title: 'AI & Machine Learning',
    summary: 'Work on intelligent avatars, agent orchestration, and signal-native AI systems.',
    focus: ['LLM integrations', 'Agent workflows', 'Evaluation & safety'],
  },
  {
    id: 'robotics-bci',
    title: 'Robotics & BCI',
    summary: 'Explore brain–computer interfaces, embodied AI, and hardware-adjacent prototypes.',
    focus: ['BCI research', 'Robotics prototyping', 'Sensor pipelines'],
  },
  {
    id: 'product-design',
    title: 'Product & Design',
    summary: 'Shape how people experience conscious technology — from concept to polished UI.',
    focus: ['UX research', 'Interface design', 'Design systems'],
  },
  {
    id: 'growth-marketing',
    title: 'Growth & Marketing',
    summary: 'Tell the SELF Labs story — content, community, launches, and partnerships.',
    focus: ['Content strategy', 'Social & community', 'Launch campaigns'],
  },
] as const;

export type InternTrackId = (typeof INTERN_TRACKS)[number]['id'];

export const AVAILABILITY_OPTIONS = [
  { value: 'summer-full-time', label: 'Summer — full-time' },
  { value: 'fall-part-time', label: 'Fall semester — part-time' },
  { value: 'spring-part-time', label: 'Spring semester — part-time' },
  { value: 'year-round-part-time', label: 'Year-round — part-time' },
  { value: 'flexible', label: 'Flexible / open to discuss' },
] as const;

export type Availability = (typeof AVAILABILITY_OPTIONS)[number]['value'];

export type InternApplication = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  school: string;
  graduationYear: string;
  major: string;
  track: InternTrackId;
  linkedinUrl: string;
  portfolioUrl: string;
  resumeUrl: string;
  availability: Availability;
  preferredStart: string;
  whySelfLabs: string;
  consent: boolean;
};

export const emptyInternApplication = (): InternApplication => ({
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  school: '',
  graduationYear: '',
  major: '',
  track: 'software-engineering',
  linkedinUrl: '',
  portfolioUrl: '',
  resumeUrl: '',
  availability: 'flexible',
  preferredStart: '',
  whySelfLabs: '',
  consent: false,
});
